module.exports = __webpack_public_path__ + "static/user3-d89e5759c382a5e0aae660cb3efcbd83.jpg";